import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=2a90bd68&scoped=true"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=2a90bd68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90bd68",
  null
  
)

export default component.exports